import {
    ArticleAvailableEvent,
    EntitledToView,
    PublicationEvents,
    PublicationType,
    RequiredAccess,
} from '@news-mono/web-common'
import H from 'history'
import React from 'react'
import { Logger } from 'typescript-log'
import {
    BreachNotificationWrapper,
    useBreachWallConfig,
} from './components/BreachNotificationWrapper/BreachNotificationWrapper'
import { createIsEntitledChangeHandler } from './createIsEntitledChangeHandler'
import { StyledFeatureArticleBreachNotification } from './FeatureArticleBreach.styled'
import { useSection } from '../../__helpers'
import { TheWestSection } from '@news-mono/common'

export interface FeatureArticleBreachProps {
    requiredAccess: RequiredAccess
    location: H.Location
    commonElements: React.ReactElement<any>
    comments?: React.ReactElement<any>
    onEvent: (event: ArticleAvailableEvent | PublicationEvents) => void
    article: PublicationType
    log: Logger
}

export const FeatureArticleBreach: React.FC<FeatureArticleBreachProps> = (
    props,
) => {
    const {
        commonElements,
        comments,
        requiredAccess,
        location,
        onEvent,
        article,
        log,
    } = props
    const section = useSection<TheWestSection>()
    const { creativeName, deal, type } = useBreachWallConfig(location, section)

    return (
        <EntitledToView
            requiredAccess={requiredAccess}
            articleSlug={article.slug}
            onIsEntitledChange={createIsEntitledChangeHandler(
                creativeName,
                deal,
                location,
                onEvent,
                article,
            )}
            entitled={() => {
                return (
                    <div>
                        {commonElements}
                        {props.children}
                        {comments}
                    </div>
                )
            }}
            notEntitled={() => {
                return (
                    <div>
                        {commonElements}
                        <StyledFeatureArticleBreachNotification>
                            <BreachNotificationWrapper
                                publication={article}
                                requiredAccess={requiredAccess}
                                breachDeal={deal}
                                breachCreativeName={creativeName}
                                onEvent={onEvent}
                                type={type}
                                blocks={[]}
                                log={log}
                            />
                        </StyledFeatureArticleBreachNotification>
                        {comments}
                    </div>
                )
            }}
        />
    )
}

FeatureArticleBreach.displayName = 'FeatureArticleBreach'
